import React, { memo, useEffect, MouseEventHandler } from 'react'
import { Card } from 'transfix-ui/components/Card'
import { InlineMessage, INLINE_MESSAGE_VARIANTS } from 'transfix-ui/components/InlineMessage'
import { Spinner } from 'transfix-ui/components/Spinner'
import useUserDetails from 'utils/hooks/useUserDetails'
import { ISMSProps } from './components/SMS'
import { SMSInput } from './components/SMSInput'
import { SMSList } from './components/SMSList'
import 'scss/5_components/_messages.scss'

interface ISMSCardProps {
  user: { id: number; firstName: string; cellPhone: string }
  to: { id: number }
  shipmentId: number
  fetchSMS: Function
  sendSMS: Function
  list?: ISMSProps[]
  fetching?: boolean
  error?: boolean
  sending?: boolean
  sendError?: string
  editUserAction?: MouseEventHandler
  cannedMessages?: any[]
}

export const SMSCard = memo<ISMSCardProps>(
  ({
    user,
    to,
    shipmentId,
    fetchSMS,
    sendSMS,
    list = [],
    fetching,
    error,
    sending,
    sendError,
    editUserAction,
    cannedMessages,
  }) => {
    const { userDetails } = useUserDetails()
    const { firstName, id, lastName, userType: sentByUserType } = userDetails || {}
    const { cellPhone, firstName: name, id: userId } = user || {}
    const { id: sendToId } = to || {}
    const ready = !fetching && !error

    useEffect(() => {
      const { length } = list
      if (shipmentId) {
        fetchSMS(shipmentId, 'shipmentId')
      } else if (userId && !length) {
        fetchSMS(userId, 'parentUserId')
      }
    }, [userId, shipmentId])

    const send = (message: string) => {
      const toId = sendToId
      sendSMS({
        toId,
        message,
        sentByUserType,
        from: { id, firstName, lastName },
      })
    }

    return (
      <Card title='Messages'>
        {fetching && <Spinner />}
        {error && (
          <InlineMessage
            message='Unable to load messages. Please try refreshing the page.'
            type={INLINE_MESSAGE_VARIANTS.ALERT}
          />
        )}
        {ready && (
          <div className='messages-content'>
            <SMSList list={list} />
            {cellPhone ? (
              <SMSInput
                cannedMessages={cannedMessages}
                submit={send}
                error={sendError}
                sending={sending}
              />
            ) : (
              <>
                <p>Add cell phone number to message {name}</p>
                {editUserAction ? (
                  <button className='btn-tertiary' onClick={editUserAction}>
                    Add cell phone number
                  </button>
                ) : (
                  <a className='btn btn-tertiary' href={`${__ROOT__}/users/${userId}`}>
                    Add cell phone number
                  </a>
                )}
              </>
            )}
          </div>
        )}
      </Card>
    )
  }
)

export default SMSCard
